@if (pagination(); as pagination) {
  @if (isMobile()) {
    <input
      id="switcher" [attr.aria-label]="'common.changeSlide' | cxTranslate"
      class="switcher" type="range" [min]="" [max]="pagination?.totalResults - 1" [value]="pagination.currentPage"
      (change)="onChangeSlide($event.target.value)"
    >
  } @else {
    <button
      [attr.aria-label]="'common.previous' | cxTranslate"
      class="btn btn-tertiary btn-item" [disabled]="pagination?.currentPage === 0"
      (click)="changeActive.emit(pagination?.currentPage - 1)"
    >
      <mat-icon svgIcon="arrow-left"></mat-icon>
      {{ 'common.previous' | cxTranslate }}
    </button>
    @for (item of items(); let i = $index; track item) {
      <button
        [attr.aria-label]="item + 1"
        [ngClass]="{active: pagination?.currentPage === item}"
        class="btn btn-tertiary btn-item" [disabled]="pagination?.currentPage === item"
        (click)="changeActive.emit(item)"
      >{{ item + 1 }}
      </button>
    }
    <button
      [attr.aria-label]="'common.next' | cxTranslate"
      (click)="changeActive.emit(pagination?.currentPage + 1)"
      class="btn btn-tertiary btn-item"
      [disabled]="pagination?.currentPage === pagination?.totalPages - 1"
    >
      {{ 'common.next' | cxTranslate }}
      <mat-icon svgIcon="arrow-right"></mat-icon>
    </button>
  }

}
